import React, { Component } from "react";
import { computed } from "mobx";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";
import { Statistic } from "semantic-ui-react";
import PropTypes from "prop-types";
import Subscription from "~/models/Subscription/Subscription";
import UiMeet3dPackageInfos from "~/constants/UiMeet3d/UiMeet3dPackageInfos";
import ProviderStatistic from "~/models/Provider/ProviderStatistic";
import CustomerStatistic from "~/models/Customer/CustomerStatistic";

@observer
class UiMeet3dSubscriptionStatisticGroup extends Component {
  @computed
  get totals() {
    const { subscription } = this.props;

    const totals = {
      activeTours: 0,
      minutes: 0,
      notifications: 0,
      leads: 0,
    };

    subscription.nextBillingCycleSubscriptionItems.forEach(item => {
      totals.activeTours += UiMeet3dPackageInfos[item.otherProductId].activeTours * item.quantity;
      totals.minutes += UiMeet3dPackageInfos[item.otherProductId].minutes * item.quantity;
      totals.notifications += UiMeet3dPackageInfos[item.otherProductId].notifications * item.quantity;
      totals.leads += UiMeet3dPackageInfos[item.otherProductId].leads * item.quantity;
    });

    return totals;
  }

  render() {
    const { t, statistic, statisticModule, showMinutes, showNotifications, showLeads } = this.props;
    const {
      activeTours: totalActiveTours,
      minutes: totalMinutes,
      notifications: totalNotifications,
      leads: totalLeads,
    } = this.totals;

    return (
      <Statistic.Group>
        <Statistic>
          <Statistic.Value>
            {statistic[statisticModule]} /{" "}
            {totalActiveTours < 1000000 ? totalActiveTours : t("clientPanelMisc:unlimited")}
          </Statistic.Value>
          <Statistic.Label>{t("clientPanelMisc:activeTours", { count: totalActiveTours })}</Statistic.Label>
        </Statistic>
        {showMinutes && (
          <Statistic>
            <Statistic.Value>
              {statistic.uiMeet3dMinutesTotal} /{" "}
              {totalMinutes < 1000000 ? totalMinutes : t("clientPanelMisc:unlimited")}
            </Statistic.Value>
            <Statistic.Label>{t("clientPanelMisc:minutesOfPrimeVideoConferencing")}</Statistic.Label>
          </Statistic>
        )}
        {showLeads && (
          <Statistic>
            <Statistic.Value>
              {statistic.uiMeet3dLeadsCount} / {totalLeads < 1000000 ? totalLeads : t("clientPanelMisc:unlimited")}
            </Statistic.Value>
            <Statistic.Label>{t("leads")}</Statistic.Label>
          </Statistic>
        )}
        {showNotifications && (
          <Statistic>
            <Statistic.Value>
              {statistic.uiMeet3dEventNotificationsCount} /{" "}
              {totalNotifications < 1000000 ? totalNotifications : t("clientPanelMisc:unlimited")}
            </Statistic.Value>
            <Statistic.Label>{t("clientPanelMisc:notifications")}</Statistic.Label>
          </Statistic>
        )}
      </Statistic.Group>
    );
  }
}

UiMeet3dSubscriptionStatisticGroup.propTypes = {
  t: PropTypes.func.isRequired,
  subscription: PropTypes.instanceOf(Subscription),
  statistic: PropTypes.oneOfType([PropTypes.instanceOf(ProviderStatistic), PropTypes.instanceOf(CustomerStatistic)]),
  statisticModule: PropTypes.string,
  showMinutes: PropTypes.bool,
  showLeads: PropTypes.bool,
  showNotifications: PropTypes.bool,
};

UiMeet3dSubscriptionStatisticGroup.defaultProps = {
  showMinutes: true,
  showLeads: true,
  showNotifications: true,
  statisticModule: "uiMeet3dActiveToursCount",
};

export default withTranslation()(UiMeet3dSubscriptionStatisticGroup);
